import { render } from "./StatusStoppedIcon.vue?vue&type=template&id=1679d703"
import script from "./StatusStoppedIcon.vue?vue&type=script&lang=js"
export * from "./StatusStoppedIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__